<template>
  <el-dialog :visible.sync="dialogVisible" title="收款二维码">
    <section class="imgPreiewBox" v-loading="loading">
      <img width="100%" :src="dialogImageUrl" alt />
      <p class="refresh primary cur" @click="getQrcode">刷新</p>
    </section>
  </el-dialog>
</template>

<script>
import {
  siteQrcode,
} from 'api/service';
import {
  getBigImg,
} from '@qx/utils';
export default {
  data () {
    return {
      dialogVisible: false,
      dialogImageUrl: '',
      loading: false,
      originData: {},
    };
  },
  methods: {
    show (item) {
      this.dialogImageUrl = '';
      this.dialogVisible = true;
      this.originData = item;
      this.getQrcode();
    },
    async getQrcode () {
      this.loading = true;
      const imgRes = await siteQrcode({
        productId: this.originData.productId,
        times: new Date().getTime(),
        oilSourceTenantId: this.originData.oilSourceTenantId,
      });
      this.dialogImageUrl = getBigImg(imgRes.qrCodeUrl);
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.refresh{
  text-align: center;
  line-height: 40px;
}
</style>
